import React from "react";
import {Typography, TypographyProps} from "@mui/material";
import {makeStyles} from "@mui/styles";


export type TypographyWithIcon = TypographyProps & {
    startIcon?: React.ReactElement
    endIcon?: React.ReactElement
}


const useStyles = makeStyles(theme => ({
    root: {
        display: "inline-flex",
        alignItems: "center"
    }
}))


export const TypographyWithIcon = (props: TypographyWithIcon) => {
    const {className, children, startIcon, endIcon, ...otherProps} = props;
    const classes = useStyles(props);
    return (
        <Typography {...otherProps} className={[className, classes.root].filter(Boolean).join(" ")}>
            {startIcon && <>{startIcon}&nbsp;</>}{children}{endIcon && <>{endIcon}</>}
        </Typography>
    )
}